import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { User } from "@/types";
import { client, syncFeed } from "@/services/client";
import { tokenStore } from "@/auth/tokenStore";

/** The signed-in user, fetched once for the header. Null until loaded / on error. */
export function useCurrentUser(): User | null {
  const [user, setUser] = useState<User | null>(null);
  useEffect(() => {
    let active = true;
    client
      .getCurrentUser()
      .then((u) => active && setUser(u))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return user;
}

/** Clear the local session + every entity collection and return to sign-in. */
export function useSignOut(): () => void {
  const navigate = useNavigate();
  return () => {
    // Best-effort server-side revoke of the whole refresh family (W11); never
    // block sign-out on it. Local state is cleared regardless.
    const refresh = tokenStore.getRefresh();
    if (refresh) void client.logout(refresh).catch(() => {});
    tokenStore.clear();
    // The next account in this browser must not see this user's data.
    syncFeed.reset();
    navigate("/signin", { replace: true });
  };
}
